var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapInfoWindow',{attrs:{"options":{ disableAutoPan: true },"opened":_vm.value},on:{"closeclick":function($event){return _vm.$emit('input', !_vm.value)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }